<template>
  <div class="page-search">
    <ml-search-bar
      @handle-search="handleSearch"
      :value.sync="searchValue"
      placeholder="输入地区/职业/年龄/ID搜索"
    />
    <div class="result-container">
      <ml-loading v-if="goddessesLoading" />
      <GridLayoutGoddess v-else :goddesses="goddesses" />
    </div>
  </div>
</template>

<script>
import GridLayoutGoddess from "@/views/home/components/GridLayoutGoddess";
import { searchGoddess } from "@/api/goddness";

export default {
  name: "GoddessSearch",
  components: {
    GridLayoutGoddess
  },
  data() {
    return {
      searchValue: "",
      goddesses: [],
      goddessesLoading: false
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.goddessesLoading = true;
      const responseData = await searchGoddess(this.searchValue);
      this.goddesses = responseData.content;
      this.goddessesLoading = false;
    },
    handleSearch() {
      console.log("点击了");
      this.fetchData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-search {
  background: #f5f5f5;
  flex-direction: column;
  .result-container {
    padding: 54px 10px 10px 10px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
}
</style>
